export const styles = {
  root: {
    height: 'calc(100svh - 450px)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderTop: '1px solid grey',
    marginTop: 16,
  },
  button: theme => ({
    width: '40px',
    height: '40px',
    border: '1px solid grey',
    '&:hover': {
      background: theme.palette.common.surface['surface 2'],
    },
  }),
  divider: {
    borderTop: '1px solid grey',
    width: '100%',
    marginTop: 16,
  },
  action: {
    background: 'none',
    '&:hover': {
      background: 'none',
    },
  },
  dataActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    justifyContent: 'center',
  },
};
